package com.milta.feature.route.data.repository

import com.milta.feature.route.data.remote.LoadingAddressApi
import com.milta.feature.route.data.remote.dto.AddLoadingAddressRequest
import com.milta.feature.route.data.remote.dto.toDomain
import com.milta.feature.route.domain.entity.LoadingAddress
import com.milta.feature.route.domain.repository.LoadingAddressRepository

class LoadingAddressRepositoryImpl(private val api: LoadingAddressApi) : LoadingAddressRepository {

    override suspend fun getLoadingAddresses(): Result<List<LoadingAddress>> =
        runCatching { api.getLoadingAddresses().map { it.toDomain() } }

    override suspend fun addLoadingAddress(address: String, latitude: Double, longitude: Double): Result<LoadingAddress> =
        runCatching { api.addLoadingAddress(AddLoadingAddressRequest(address, latitude, longitude)).toDomain() }

    override suspend fun deleteLoadingAddress(id: String): Result<Unit> =
        runCatching { api.deleteLoadingAddress(id) }
}
